export const baseEvent = {
  context: 'USER_METADATA',
} as const

export enum BaseEventTypes {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}
